import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RequestStatuses } from 'src/app/constants/status.enum';
import { RequestItemInDashboard } from 'src/app/models/dashboard';
import { PlatformHubService } from 'src/app/services/platformhub.service';
import { RequestActionTypeEnum, VerifyRequestActionService } from 'src/app/services/verify-request-action.service';

@Component({
    selector: 'app-dashboard-action-dropdown',
    templateUrl: './dashboard-action-dropdown.component.html'
})
export class DashboardActionDropdownComponent {
    @Input() selectedRequests!: RequestItemInDashboard[];
    @Output() actionSelected = new EventEmitter<string>();

    /**
     * Whether any Request have been 'Selected' for further actions
     */
    get hasSelectedRequest(): boolean {
        return (this.selectedRequests != undefined &&
            this.selectedRequests != null &&
            this.selectedRequests.length > 0);
    }

    constructor(public platformHubService: PlatformHubService,
        private verifyRequestActionService: VerifyRequestActionService) {
    }


    applyAction(action: string) {
        this.actionSelected.emit(action);
    }

    downloadAllowed() {
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable => this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.Download)
            );
    }
    exportAllowed() {
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable => this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.Export)
            );
    }
    purgeAllowed() {
        let allowPurgeStatuses: string[] = RequestStatuses.ThatCanBe_Purged;
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable =>
                // Status must match for ALL selected:
                allowPurgeStatuses.includes(selectedRequestFromTable.status)
                && // we need ACCES to ALL selected::
                this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.Purge)
            );
    }
    deleteAllowed() {
        let deleteStatussen: string[] = RequestStatuses.ThatCanBeDeleted;
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable =>
                // Status must match for ALL selected:
                deleteStatussen.includes(selectedRequestFromTable.status)
                && // we need ACCES to ALL selected::
                this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.DELETE)
            );
    }
    changeWorkgroupAllowed() {
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable => this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.ChangeWorkGroup)
            );
    }
    sendReminderAllowed() {
        let sendReminderAllowedStatussen: string[] = RequestStatuses.ThatCanBeReminded;
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable =>
                // Status must match for ALL selected:
                sendReminderAllowedStatussen.includes(selectedRequestFromTable.status)
                && // we need ACCES to ALL selected::
                this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.SendReminder)
            );
    }
    withdrawAllowed() {
        let withdrawAllowedStatussen: string[] = RequestStatuses.ThatCanBeWithdrawn;
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable =>
                // Status must match for ALL selected:
                withdrawAllowedStatussen.includes(selectedRequestFromTable.status)
                && // we need ACCES to ALL selected::
                this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.Withdraw)
            );
    }
    changeOwnerAllowed() {
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable => this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.BecomeOwner)
            );
    }
    restoreAllowed() {
        let restoreStatussen: string[] = RequestStatuses.ThatCanBeRestored;
        return this.hasSelectedRequest &&
            this.selectedRequests.every(selectedRequestFromTable =>
                // Status must match for ALL selected:
                restoreStatussen.includes(selectedRequestFromTable.status)
                && // we need ACCES to ALL selected::
                this.verifyRequestActionService.IsAllowed(selectedRequestFromTable, RequestActionTypeEnum.Restore)
            );
    }

}
